export default "__VITE_ASSET__BCI6okrj__"